<p class="max-w-[70%] text-[16px] font-bold text-primary mt-0 mb-3">
  {{ saga.name }}
</p>

@if (!content || content.length === 0) {
<app-skeleton-works [user]="user"></app-skeleton-works>
} @else {
<div class="relative max-w-full">
  <section
    class="cards-list grid [--g:clamp(18px,2vw,30px)] gap-[var(--g)] [grid-template-columns:repeat(auto-fill,minmax(min(clamp(146px,9vw,190px),calc((100%_-_var(--g))/2)),1fr))]"
  >
    @for (item of content; track trackByFn($index, item)) {
    <app-work-card
      [fullyLoaded]="true"
      [isMobile]="isMobile"
      [item]="item"
      [type]="item.type"
      [user]="user"
      [ongoing]="false"
      [releases]="false"
      [upcoming]="false"
      [hasMultipleTypes]="false"
    ></app-work-card>
    }
  </section>
</div>
}
